import React from "react"

import WidgetHeaderButton from "./WidgetHeaderButton"
import FilterCloseButton from "./FilterCloseButton"

export default ({
    clearFilter,
    requestFilterSearch,
    closeFilter,
    children
}) => (
    <div className="widget with-filter">
        <h3 className="widget-header">
            <span className="icon icon-filter" />Filter
            <div className="pull-right edge-pull-right-fix">
                <WidgetHeaderButton isSecondary={true} onClick={clearFilter}>
                    Clear
                </WidgetHeaderButton>
                <WidgetHeaderButton onClick={requestFilterSearch}>
                    Filter
                </WidgetHeaderButton>
                <FilterCloseButton onClick={closeFilter} />
            </div>
        </h3>
        <div className="widget-content widget-content-filter auto">
            {children}
        </div>
    </div>
)
